import {createQueryKeys} from "../../shared/query/query-keys";

export const serviceKeys = createQueryKeys("services");

export const serviceMutationKeys = {
  createService: ["services", "mutation", "create-service"] as const,
  updateService: ["services", "mutation", "update-service"] as const,
  restoreService: ["services", "mutation", "restore-service"] as const,
  deleteService: ["services", "mutation", "delete-service"] as const,
  updateServiceComposition: ["services", "mutation", "update-service-composition"] as const,
  addServiceDescription: ["services", "mutation", "add-service-description"] as const,
  editServiceDescription: ["services", "mutation", "edit-service-description"] as const,
  addServiceFunction: ["services", "mutation", "add-service-function"] as const,
  removeServiceFunction: ["services", "mutation", "remove-service-function"] as const,
  addServiceNote: ["services", "mutation", "add-service-note"] as const,
  editServiceNote: ["services", "mutation", "edit-service-note"] as const,
  removeServiceNote: ["services", "mutation", "remove-service-note"] as const,
};
